module.exports = "/_next/static/images/84f37f4e8a226201ea30ad19d06a30b5-minimo_rotativo.png.webp";